import { render } from "./TimeSlotItemSectors.vue?vue&type=template&id=665943c4&scoped=true&ts=true"
import script from "./TimeSlotItemSectors.vue?vue&type=script&lang=ts"
export * from "./TimeSlotItemSectors.vue?vue&type=script&lang=ts"

import "./TimeSlotItemSectors.vue?vue&type=style&index=0&id=665943c4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665943c4"]])

export default __exports__